import React from 'react';
import ItemList from '../components/ItemList'
import AddItem from '../components/AddItem'

function List() {
  return (
      <>
          < AddItem />
          < ItemList />
      </>
  );
}

export default List;